import Exception from "components/Exception";
import useText from "constants/text";
import React from "react";
import { useNavigate } from "react-router-dom";
import { noProgramStyles } from "../style";

function NoProgram() {
  const { text } = useText();
  const navigate = useNavigate();
  const navigateToAllPrograms = () => {
    navigate("/fidelity/programs", { replace: true });
  };
  return (
    <Exception
      primaryText=""
      othersText={[
        <div style={noProgramStyles.container}>
          {text.fidelity_program.sorry_to_not_register}
          <span style={noProgramStyles.link} onClick={navigateToAllPrograms}>
            {`${text.fidelity_program.title} `}
          </span>
          {text.fidelity_program.you_can_see_benefits}
        </div>,
      ]}
    />
  );
}

export default NoProgram;
